jQuery(document).ready(function($) {
  'use strict';

  function FormUpload(element) {
    this.container = element;
    this.settings = {
      maxAantalFiles: this.container.attr('data-formupload-maxfiles'),
      maxMB: this.container.attr('data-formupload-maxmb'),
      allowedExtensions: this.container.attr('data-formupload-allowedextensions'),
      currentMB: 0,
      key: this.container.attr('data-formupload-key'),
      currentUploadingFiles: 0
    };
    this.bindEvents();

    // multiple files not working on ipad safari
    if (navigator.userAgent.match(/iPad/i) !== null && navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
      this.getElement('.ipo-form-fileupload__inputfile').prop('multiple', false);
    }
  }

  FormUpload.prototype.getDOMElement = function(selector) {
    var element = this.container.find(selector);

    if (element.length > 0) {
      return element.get(0);
    }

    return null;
  }

  FormUpload.prototype.getElement = function(selector) {
    return this.container.find(selector);
  }

  FormUpload.prototype.removeFileFromInput = function(filename) {
    var inputFiles = this.getDOMElement('#' + this.settings.key),
        files = inputFiles.value.split('*'),
        newValue = '',
        fileRemoved = false;

    files.forEach(function(file) {
      if (file.length > 0) {
        if (file.startsWith(filename + '|') && !fileRemoved) {
          fileRemoved = true;
        } else {
          newValue = newValue + file + '*';
        }
      }
    });

    inputFiles.value = newValue;
  }

  FormUpload.prototype.checkIfMessageContainerIsAvailable = function() {
    var uploadcontrol,
        messageContainer = this.getDOMElement('.ipo-form-fileupload__fileuploadMessage');

    if (messageContainer === null) {
      uploadcontrol = this.getDOMElement('.ipo-form-fileupload__uploadcontrol');
      uploadcontrol.insertAdjacentHTML('beforebegin', '<div class="ipo-form-fileupload__fileuploadMessage"></div>');
    } 
  }

  FormUpload.prototype.resetmessage = function() {
    var messageContainer;

    this.checkIfMessageContainerIsAvailable();
    messageContainer = this.getDOMElement('.ipo-form-fileupload__fileuploadMessage');
    messageContainer.innerHTML = '';
    
  }

  FormUpload.prototype.addmessage = function(tekst) {
    var messageContainer;

    this.checkIfMessageContainerIsAvailable();
    messageContainer = this.getDOMElement('.ipo-form-fileupload__fileuploadMessage');
    
    if (messageContainer.innerHTML === '') {
      messageContainer.innerHTML = tekst;
    } else {
      messageContainer.innerHTML = m.innerHTML + '<br>' + tekst;
    }
  }

  FormUpload.prototype.deleteFile = function (element) {
    var elem = jQuery(element),
        sizeDeletedFile = 0;

    sizeDeletedFile = parseFloat(elem.parent().attr('size'));
    this.settings.currentMB = this.settings.currentMB - sizeDeletedFile;
    elem.parent().remove();
    this.resetmessage();
    this.removeFileFromInput(elem[0].getAttribute('file'));

    if (this.getElement('.ipo-form-fileupload__uploadedfiles li').length < this.settings.maxAantalFiles) {
      this.container.removeClass('maxbereikt');
      this.getDOMElement('.ipo-form-fileupload__inputfile').disabled = false;
    }
  }

  FormUpload.prototype.createString = function(filename, displayname, filesize, base64) {
    return filename + '|' + displayname + '|' + filesize + '|' + base64 + '*';
  }

  FormUpload.prototype.addfile = function (file) {
    var self, regex;
    
    self = this;
    regex = RegExp('.(' + self.settings.allowedExtensions + ')$');
    if (regex.test(file.name)) {
      if (self.settings.currentMB + file.size / 1024 / 1024 > self.settings.maxMB) {
        self.addmessage(file.name + ' is niet toegevoegd. U kunt in totaal maximaal ' + self.settings.maxMB + 'MB toevoegen.');
        self.finishFileUpload();
      } else {
        self.settings.currentMB = self.settings.currentMB + file.size / 1024 / 1024;
        if (file.type === "application/pdf") {
          self.readPdfFile(file);
        } else {
          self.readFileAsBase64(file);
        }
        
      }
    } else {
      self.addmessage(file.name + ' is niet toegevoegd. Alleen bestanden met de volgende extensise kunnen toegevoegd worden: ' + self.settings.allowedExtensions.replace('|', ', ') +'.');
      self.finishFileUpload();
    }
  }

  FormUpload.prototype.finishFileUpload = function() {
    this.settings.currentUploadingFiles = this.settings.currentUploadingFiles - 1;

    if (this.settings.currentUploadingFiles <= 0) {
      this.getElement('.lds-ring').addClass('hide');
    }
  }

  FormUpload.prototype.readPdfFile = function(file) {
    var reader, self;

    self = this;

    reader = new FileReader();
    reader.readAsText(file);
    reader.onload = function() {
      if (reader.result.lastIndexOf("%PDF-") === 0 && reader.result.lastIndexOf("%%EOF") > -1) {
        self.readFileAsBase64(file);
      } else {
        self.addmessage('Het document \'' + file.name + '\' is niet toegevoegd. Dit document is geen geldig PDF-bestand.');
        self.finishFileUpload();
      }
    }
  };

  FormUpload.prototype.readFileAsBase64 = function(file) {
    var reader, self;

    self = this;

    reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {

      self.fileReadingComplete(file, reader.result)
    };
  }

  FormUpload.prototype.fileReadingComplete = function(file, data) {
    var  d, d1, size, inputFiles, newFile, data, bestandsnaam, displaynaam;

    size = (file.size / 1024 / 1024).toFixed(2);
    bestandsnaam = Date.now() + '_' + file.name;
    displaynaam = file.name;

    d1 = this.getDOMElement('.ipo-form-fileupload__uploadedfiles');
    d1.insertAdjacentHTML('beforeend',
      '<li class="ipo-form-fileupload__uploadedfile" size="' + size + '"><div class="ipo-form-fileupload__uploadedfile-thumb ial-al_027"></div><div class="ipo-form-fileupload__uploadedfile-name">' + displaynaam + '</div><img class="delete" src="/assets/icons/prullenbak-zwart.svg" file="' + bestandsnaam + '"></li>');

    inputFiles = this.getDOMElement('#' + this.settings.key);

    if (inputFiles === null) {
      d = this.getDOMElement('.ipo-form-fileupload__upload');
      d.insertAdjacentHTML('beforebegin', '<input hidden class="hidden" type="text" id="' +  this.settings.key + '" name="' +  this.settings.key + '" value="' + this.createString(bestandsnaam, displaynaam, size, data) + '">');
    } else {
      newFile = this.createString(bestandsnaam, displaynaam, size, data);
      if (inputFiles.value.endsWith('*')) {
        inputFiles.value = inputFiles.value + newFile;
      } else {
        inputFiles.value = inputFiles.value + '*' + newFile;
      }
    }

    this.finishFileUpload();
    if (this.getElement('.ipo-form-fileupload__uploadedfiles li').length >= this.settings.maxAantalFiles) {
      this.getElement('.ipo-form-fileupload__inputfile').prop('disabled', 'disabled');
      this.container.addClass('maxbereikt');
    }
  }

  FormUpload.prototype.readfiles = function(files) {
    var i,
        aantalBestandenToevoegen = files.length;

    this.resetmessage();
    if (this.getElement('.ipo-form-fileupload__uploadedfiles li').length >= this.settings.maxAantalFiles) {
      this.addmessage(this.errorMaxBestanden());
      aantalBestandenToevoegen = 0;
    } else if ((files.length + this.getElement('.ipo-form-fileupload__uploadedfiles li').length) > this.settings.maxAantalFiles) {
      this.addmessage('Niet alle bestanden zijn toegevoegd. ' + this.errorMaxBestanden());
      aantalBestandenToevoegen = this.settings.maxAantalFiles - this.getElement('.ipo-form-fileupload__uploadedfiles li').length;
    }

    if (aantalBestandenToevoegen > 0) {
      this.getElement('.lds-ring').removeClass('hide');
    }
    this.settings.currentUploadingFiles = this.settings.currentUploadingFiles + aantalBestandenToevoegen;
    for (i = 0; i < aantalBestandenToevoegen; i++) {
      this.addfile(files[i]);
    }
  }

  FormUpload.prototype.errorMaxBestanden = function() {
    if (this.settings.maxAantalFiles == 1) {
      return 'U kunt maximaal 1 bestand toevoegen.';
    }

    return 'U kunt maximaal ' + this.settings.maxAantalFiles + ' bestanden toevoegen.';
  }

  FormUpload.prototype.bindEvents = function() {
    var self, mdc_filesInput, mdc_uploadedfiles;
    self = this;

    self.container.on('click', '.delete', function() {
      self.deleteFile($(this));
    });

    self.container.on({
      dragover: function() {
        return false;
      },
      drop: function(e) {
        var dt, files;
  
        e.preventDefault();
        e.stopPropagation();
  
        if ($(e.target).hasClass('dropzone')) {
          dt = e.dataTransfer || (e.originalEvent && e.originalEvent.dataTransfer);
          files = e.target.files || (dt && dt.files);
  
          if (files.length > 0) {
            if (self.getElement('.ipo-form-fileupload__uploadedfiles li').length >= self.settings.maxAantalFiles) {
              self.addmessage(self.errorMaxBestanden());
            } else {
              self.readfiles(files);
            }
          }
        }
      }
    });

    mdc_filesInput = self.getDOMElement('.ipo-form-fileupload__inputfile');

    if (mdc_filesInput !== null) {
      mdc_filesInput.addEventListener('change', function() {
        if (mdc_filesInput.files.length > 0) {
          self.readfiles(mdc_filesInput.files);
          mdc_filesInput.value = null;
        }
      });
      mdc_uploadedfiles = self.getDOMElement('.ipo-form-fileupload__uploadedfiles');
      if (mdc_uploadedfiles !== null) {
        if (self.getElement('.ipo-form-fileupload__uploadedfiles li').length > 0) {
          self.settings.currentMB = parseFloat(mdc_uploadedfiles.getAttribute('fs'));

          if (self.getElement('.ipo-form-fileupload__uploadedfiles li').length >= self.settings.maxAantalFiles) {
            self.container.addClass('maxbereikt');
            self.getElement('.ipo-form-fileupload__inputfile').prop('disabled', 'disabled');
          }
        }
      }
    }
  }

  $(document).ready(function() {
    $('.ipo-form-fileupload').each(function() {
      new FormUpload($(this));
    })
  })
});
